<div class="container h-full flex flex-col gap-4 mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex flex-wrap items-center gap-2 min-h-10">
    <h2 class="text-2xl font-medium">Downloads</h2>
  </div>

  <div>
    <mat-chip-listbox
      hideSingleSelectionIndicator
      class="inline-flex! py-1 px-2 bg-white rounded-full [--mdc-chip-outline-color:transparent] [--mdc-chip-container-shape-radius:24px] [--mdc-chip-label-text-color:var(--color-gray-500)] [--mdc-chip-elevated-selected-container-color:var(--color-secondary-200)]  [--mdc-chip-selected-label-text-color:var(--color-secondary-800)]"
      (change)="handleTypeChange($event)"
    >
      <mat-chip-option value="" selected [selectable]="selectedFilterType() !== ''"
        >Alle</mat-chip-option
      >

      @for (option of options; track $index) {
        <mat-chip-option
          [value]="option.value"
          [selectable]="selectedFilterType() !== option.value"
          >{{ option.displayValue }}</mat-chip-option
        >
      }
    </mat-chip-listbox>
  </div>

  <app-data-table-container class="rounded-lg">
    <table
      mat-table
      matSort
      matSortDirection="desc"
      matSortActive="created_at"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="title" sticky>
        <th mat-header-cell *matHeaderCellDef>Naam</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="element.title"
            matTooltipPosition="after"
            >{{ element.title }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="text-xs font-medium px-3 py-2 rounded-full"
            [ngClass]="{
              'bg-blue-100 text-blue-950': element.type === 'release_notes',
              'bg-orange-100 text-orange-950': element.type === 'roadmap',
              'bg-green-100 text-green-950': element.type === 'manual',
            }"
          >
            {{ element.type | mapFrom: typeMapping }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell mat-sort-header="created_at" *matHeaderCellDef>Aangemaakt op</th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button matTooltip="Bekijken" (click)="handleOpenFile(element)">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:!bg-gray-100 whitespace-nowrap"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      (page)="handlePageChange($event)"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </app-data-table-container>
</div>
